import React, { useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { makeStyles } from '@material-ui/core';
import TopBar from './TopBar';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { GlobalToastMessage } from 'src/app/components/GlobalToastMessage';

const DashboardLayout = () => {
  const navigate = useNavigate();
  useEffect(() => {
    if (!localStorage.getItem('access-token')) navigate('/login');
  }, [navigate]);
  const classes = useStyles();
  const [isMobileNavOpen, setMobileNavOpen] = useState(false);

  return (
    <div className={classes.root}>
      {window.location.pathname !== '/login' &&
        window.location.pathname !== '/register' && (
          <TopBar
            onMobileNavOpen={() => {
              setMobileNavOpen(true);
            }}
          />
        )}
      <div
        className="container-fluid"
        style={{ marginTop: '66px', overflowY: 'auto', padding: '0 0' }}
      >
        <Outlet />
        <GlobalToastMessage />
        <ToastContainer />
      </div>
    </div>
  );
};

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    display: 'flex',
    height: '100vh',
    overflow: 'hidden'
    // width: '100vw'
  },
  wrapper: {
    display: 'flex',
    position: 'relative',
    flex: '1 1 auto'
  },
  contentContainer: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden'
  },
  content: {
    flex: '1 1 auto',
    width: '100vw',
    height: 'calc(100% - 80px)',
    overflow: 'auto'
  }
}));

export default DashboardLayout;
